import firebase from "firebase/app";
import Vue from "vue";
import {
  getAccessories,
  getAllAccessories,
  updateAccessory,
  removeAccessory,
  addAccessory,
  getAccessoriesByName,
} from "../../services/accessories";
import { updateProduct } from "../../services/wines";
const initState = () => {
  return {
    $listProducts: [],
    accessories: [],
  };
};

const products = {
  state: {
    $listProducts: initState().$listProducts,
    accessories: initState().accessories,
  },

  getters: {
    $listProducts: (state) => state.$listProducts,
    accessories: (state) => state.accessories,
  },

  mutations: {
    RESET_LIST_PRODUCTS(state) {
      state.$listProducts = [];
    },
    GET_LIST_PRODUCT(state) {
      state.$listProducts = [];
      let db = firebase.firestore();
      var bits = localStorage.getItem("bits");
      db.collection(process.env.VUE_APP_WINE + bits)
        .where("tags", "array-contains", "Rượu")
        .orderBy("name")
        .get()
        .then((res) => {
          res.forEach((wine) => {
            state.$listProducts.push({
              id: wine.id,
              data: wine.data(),
            });
          });
          state.$listProducts.sort(function(a, b) {
            return a.data.index - b.data.index;
          });
        });
    },
    GET_PRODUCT(state, payload) {
      let db = firebase.firestore();
      var bits = localStorage.getItem("bits");
      db.collection(process.env.VUE_APP_WINE + bits)
        .doc(payload)
        .get()
        .then((res) => {
          if (res.exists) {
            state.$listProducts.push({
              id: res.id,
              data: res.data(),
            });
            state.$listProducts.sort(function(a, b) {
              var nameA = a.data.name.toUpperCase();
              var nameB = b.data.name.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              // the same name
              return 0;
            });
          }
        });
    },
    DELETE_PRODUCT(state, payload) {
      let index = state.$listProducts.findIndex((el) => {
        return el.id === payload.id;
      });
      state.$listProducts.splice(index, 1);
    },
    EDIT_PRODUCT(state, payload) {
      let index = state.$listProducts.findIndex((el) => {
        return el.id === payload;
      });
      let db = firebase.firestore();
      var bits = localStorage.getItem("bits");
      db.collection(process.env.VUE_APP_WINE + bits)
        .doc(payload)
        .get()
        .then((res) => {
          if (res.exists) {
            state.$listProducts[index] = {};
            state.$listProducts[index] = {
              id: res.id,
              data: res.data(),
            };
          }
        });
    },
    UPDATE_PRODUCT: (state, wine) => {
      let index = state.$listProducts.findIndex((item) => item.id === wine.id);
      if (index !== -1) Vue.set(state.$listProducts, index, wine);
      state.$listProducts.sort(function(a, b) {
        return a.data.index - b.data.index;
      });
    },

    SET_ACCESSORIES: (state, res) => {
      res.forEach((wine) => {
        state.accessories.push({
          id: wine.id,
          data: wine.data(),
        });
      });
      state.accessories.sort(function(a, b) {
        return a.data.index - b.data.index;
      });
    },
    UPDATE_ACCESSORY: (state, accessory) => {
      let index = state.accessories.findIndex(
        (item) => item.id === accessory.id
      );
      if (index !== -1) Vue.set(state.accessories, index, accessory);
      state.accessories.sort(function(a, b) {
        return a.data.index - b.data.index;
      });
    },
    REMOVE_ACCESSORY: (state, id) => {
      let index = state.accessories.findIndex((item) => item.id === id);
      if (index !== -1) state.accessories.splice(index, 1);
    },
    ADD_ACCESSORY: (state, item) => {
      state.accessories.push({
        id: item.id,
        data: item.data(),
      });
      state.accessories.sort(function(a, b) {
        return a.data.index - b.data.index;
      });
    },
  },

  actions: {
    // wines
    updateProduct({ dispatch, commit }, wine) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("FLAG_LOADING", true);
          await updateProduct(wine);
          commit("UPDATE_PRODUCT", wine);
          dispatch("FLAG_LOADING", false);
          resolve();
        } catch (error) {
          dispatch("FLAG_LOADING", false);
          reject(error);
        }
      });
    },

    // accessories
    getAccessories({ commit }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getAccessories(
            data.filter,
            data.limit,
            data.after.data.orderBy,
            data.orderType
          );
        } catch (error) {}
      });
    },
    getAccessoriesByName({ commit }, name) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getAccessoriesByName(name);
          res.forEach((item) => {
            commit("ADD_ACCESSORY", item);
          });
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    addAccessory({ dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("FLAG_LOADING", true);
          await addAccessory(payload.ref, payload.accessory);
          dispatch("FLAG_LOADING", false);
          resolve();
        } catch (error) {
          dispatch("FLAG_LOADING", false);
          reject(error);
        }
      });
    },
    getAllAccessories({ commit, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("FLAG_LOADING", true);
          const res = await getAllAccessories();
          commit("SET_ACCESSORIES", res);
          resolve(res);
          dispatch("FLAG_LOADING", false);
        } catch (error) {
          dispatch("FLAG_LOADING", false);
          reject(error);
        }
      });
    },
    updateAccessory({ commit, dispatch }, accessory) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("FLAG_LOADING", true);
          await updateAccessory(accessory);
          commit("UPDATE_ACCESSORY", accessory);
          dispatch("FLAG_LOADING", false);
          resolve();
        } catch (error) {
          dispatch("FLAG_LOADING", false);
          reject(error);
        }
      });
    },
    removeAccessory({ commit, dispatch }, accessory) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("FLAG_LOADING", true);
          await removeAccessory(accessory.id);
          commit("REMOVE_ACCESSORY", accessory.id);
          dispatch("FLAG_LOADING", false);
          resolve();
        } catch (error) {
          dispatch("FLAG_LOADING", false);
          reject(error);
        }
      });
    },
  },
};

export default products;
